import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import Data from "source/app/services/Data";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import { ICalendarState } from "../../ICalendarState";
import { WithCalendarEventsChangingIndicatorAsync } from "../../CalendarEvents/Render/Editor/WithCalendarEventsChangingIndicatorAsync";
import * as toastr from "toastr";

export const DeleteCalendarEventActionAsync = async (
    eventData: ICalendarEvent
) => {
    toastr.info(`Deleting calendar event ${eventData.completionEventId}`);
    console.log(`[Calendar] deleting event`, eventData);

    await WithCalendarEventsChangingIndicatorAsync(eventData, async () => {
        await WithAnimatedProgressBarAsync(() =>
            MotwLogicServer.DeleteCalendarEventAsync({ ...eventData })
        );

        await Data.Load.Single.ByStateTarget<ICalendarState>(`eventData`);
    });
};
